import * as React from 'react';

export default props => {
  return [
    <div className="row">
      <div className="col s12 center">
        <h3>How encryption works</h3>
      </div>
    </div>,

    <div className="row">
      <div className="col s12">
        <p>The first time you will enter your password:</p>
        <ul className="collection">
          <li className="collection-item">
            Your password is <a href="https://en.wikipedia.org/wiki/Hash_function">hashed</a> once (Using{' '}
            <a href="https://en.wikipedia.org/wiki/SHA-2">SHA256</a>). The hash created is used locally as a{' '}
            <b>secure key</b> to encrypt your data.
          </li>
          <li className="collection-item">
            Your <b>secure key</b> is hashed again and send to the server. This key is then saved so that the server can
            verify you the next time you enter your password. Note that the server will never learn your original
            password so please make sure you will never forget it or else you could lose access to your data.
          </li>
          <li className="collection-item">
            When you enter a value this value is encrypted using your <b>secure key</b> and the{' '}
            <a href="https://en.wikipedia.org/wiki/Advanced_Encryption_Standard">AES</a> algorithm. Only the encrypted
            value is sent to the server. You <b>secure key</b> is the only key that can decrypt those values.
          </li>
          <li className="collection-item">
            Your secure key will be saved in your browsers local storage so that you will not have to type it on every
            refresh.
          </li>
          <li className="collection-item">If you access kimbix from a public device please don't forget to logout.</li>
        </ul>
      </div>
    </div>,

    <div className="row">
      <div className="col s12">
        <p>The next time you visit kimbix after a logout:</p>
        <ul className="collection">
          <li className="collection-item">
            You will be asked to enter your password. It will be hashed twice (the first hash is your <b>secure key</b>)
            and sent to the server. If it matches the password saved in the server you will be logged in. The server
            will send you your data and the browser will use your <b>secure key</b> to decrypt those data.
          </li>
        </ul>
      </div>
    </div>,

    <div className="row">
      <div className="col s12">
        <p>Skipping this step now:</p>
        <ul className="collection">
          <li className="collection-item">
            There is no way to enable the encryption if you skip this step at the moment. However we plan to make this
            possible in the future.
          </li>
        </ul>
      </div>
    </div>,

    <div className="row">
      <div className="col s12">
        <p>Changing your password:</p>
        <ul className="collection">
          <li className="collection-item">
            There is no way to change your password at the moment. We plan to make this possible in the future. For now
            please make sure you use a secure password that you will not lose. You can use services like lastpass or
            onepass to ensure this.
          </li>
        </ul>
      </div>
    </div>
  ] as any;
};



// WEBPACK FOOTER //
// ./src/pages/learn-more.tsx